module.exports = {
  load_error: 'This page could not be loaded. Please try again or contact your administrator.',
  retry_loading: 'Try again',
  imprint: 'Imprint',
  my_profile: 'My profile',
  open_chat: 'Open Chat',
  request_chat_access: 'Request an admin to enable chatting with {username}',
  request_chat_access_info: 'You have requested chatting with {username} on the {date}.',
  request_access_to_show_more: 'Request access to show more information.',
  request_chat_access_sent: 'Request sent',
  invalid_user_id: 'Invalid user ID',
  about_me: 'About me',
  responsibilities: "What I'm responsible for",
  expertise: "What I'm most knowledgeable about",
  // Profile entry questions
  job_description_question: 'What is your job description?',
  about_me_question: 'What would you like us to know about you?',
  responsibilities_question: 'What are you responsible for in your job?',
  expertise_question: 'What are you most knowledgeable about?',
}
